import { motion } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import site from "@/seo/site.json";

export default function Faq({ items = site.faq, eyebrow = site.sections.faq.eyebrow, heading = site.sections.faq.heading }) {
  return (
    <section id="faq" className="relative py-24 lg:py-32 px-4 sm:px-8 lg:px-16 bg-charcoal/40 border-y border-white/5" data-testid="faq-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-signal">{eyebrow}</span>
          <h2 className="mt-3 font-head font-extrabold tracking-tight text-base md:text-lg text-slate-300 leading-relaxed">
            {heading}
          </h2>
          <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-slate-500">
            Signal opens — {site.launchDateLabel}
          </p>
        </motion.div>

        <div className="lg:col-span-8 divide-y divide-white/10 border-y border-white/10">
          {items.map((f, i) => (
            <motion.details
              key={f.q}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
              className="group"
              data-testid={`faq-item-${i}`}
            >
              <summary className="flex items-center justify-between gap-6 py-5 cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                <h3 className="font-head font-bold tracking-tight text-base sm:text-lg text-white group-hover:text-signal transition-colors duration-300">
                  {f.q}
                </h3>
                <Plus
                  size={18}
                  className="shrink-0 text-signal transition-transform duration-300 group-open:rotate-45"
                />
              </summary>
              <p className="pb-6 pr-10 text-sm sm:text-base text-slate-400 leading-relaxed" data-testid={`faq-answer-${i}`}>
                {f.a}
              </p>
              {f.link && (
                <Link
                  to={f.link.to}
                  data-testid={`faq-link-${i}`}
                  className="-mt-2 mb-6 inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-signal hover:text-white transition-colors"
                >
                  {f.link.label}
                  <ArrowUpRight size={12} />
                </Link>
              )}
            </motion.details>
          ))}
        </div>
      </div>
    </section>
  );
}
